<template>
  <div class="content">
    <div class="demo-drawer__content">
      <el-form :label-position="labelPosition"
               :model="form"
               :inline="true"
               size="small">
        <el-form-item label="机构简称">
          <el-select v-model="form.cid"
                     placeholder="请选择"
                     filterable
                     @change="submit"
                     clearable>
            <el-option v-for="item in $store.state.CompanyList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- $store.state.userroleList -->
        <el-form-item label="角色">
          <el-select v-model="form.role"
                     placeholder="请选择"
                     @change="submit"
                     clearable>
            <el-option v-for="item in userroleOption"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间"
                      prop="last_advance_time">
          <el-date-picker v-model="create_time"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="timestamp"
                          @change="submit">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="统计时间"
                      prop="last_advance_time">
          <el-date-picker v-model="statistic_time"
                          type="daterange"
                          align="right"
                          unlink-panels
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="timestamp"
                          @change="submit">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="最近发单时间"
                      prop="last_order_time_type">
          <el-select v-model="last_order_time_type"
                     placeholder="请选择最近发单时间"
                     @change="submit"
                     clearable>
            <el-option v-for="(item,index) in  timeArr"
                       :key="index"
                       :label="item.label"
                       :value="item.value">

            </el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="remark_keyword"
                    placeholder="请输入备注"
                    @input="getList()"
                    clearable></el-input>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <!--         <el-button @click="emitClose" class="elbutton" size="small"
          >取 消</el-button
        >
        <el-button type="primary" class="elbutton" size="small">确定</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //
  props: {
    userroleOption: {
      default: [],
    },
  },
  data() {
    return {
      remark_keyword: '',
      form: {},
      labelPosition: 'left',
      create_time: '',
      statistic_time: '',
      last_order_time_type: '',
      timeArr: [
        {
          label: '7天内',
          value: '1',
        },
        {
          label: '15天内',
          value: '2',
        },
        {
          label: '30天内',
          value: '3',
        },
        {
          label: '超过30天',
          value: '4',
        },
        {
          label: '超过90天',
          value: '5',
        },
        {
          label: '超一年',
          value: '6',
        },
        {
          label: '无发单',
          value: '7',
        },
      ],
    }
  },
  methods: {
    emitClose() {
      this.$emit('close')
    },
    getList() {
      if (this.remark_keyword != '') {
        this.form.remark_keyword = this.remark_keyword
        this.$emit('submit', { screenForm: this.form })
      }
    },
    submit() {
      // 创建时间区间处理
      if (this.create_time) {
        this.form.start_create_time = this.create_time[0]
        this.form.end_create_time = this.create_time[1] + 86399000
      } else {
        this.form.start_create_time = ''
        this.form.end_create_time = ''
      }

      if (this.statistic_time) {
        this.form.statistic_start_time = this.statistic_time[0]
        this.form.statistic_end_time = this.statistic_time[1] + 86399000
      } else {
        this.form.statistic_start_time = ''
        this.form.statistic_end_time = ''
      }
      if (this.last_order_time_type) {
        this.form.last_order_time_type = this.last_order_time_type
      }

      this.$emit('submit', { screenForm: this.form })
    },
  },
}
</script>

<style lang="less" scoped>
.demo-drawer__content {
  padding-top: 24px;
  height: 100%;
}
.el-form {
}
.demo-drawer__footer {
  margin-bottom: 24px;
  float: right;
}
</style>